function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { animate, motion, useMotionValue, useTransform } from "framer-motion";
import React, { useEffect } from "react";
import { isTruthy } from "../../../utils/isTruthy";
import { MarkupText } from "./MarkupText";
export function ParagraphMetrics(props) {
    var _props_metrics, _props_metrics1;
    return /*#__PURE__*/ React.createElement("div", {
        className: "paragraph-container container-page flex flex-col items-center bg-gradient-to-t from-green-50 via-green-50/60 to-green-50/0 gap-6 md:gap-16"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-8 items-center md:w-[90%]"
    }, props.title && /*#__PURE__*/ React.createElement("h2", {
        className: "m-0"
    }, props.title), props.description && /*#__PURE__*/ React.createElement("section", {
        className: "w-full"
    }, /*#__PURE__*/ React.createElement(MarkupText, {
        markup: props.description,
        classNames: {
            p: " last:mb-0"
        }
    }))), /*#__PURE__*/ React.createElement("div", {
        className: "md:flex md:flex-row md:flex-wrap justify-center gap-6 hidden"
    }, (_props_metrics = props.metrics) === null || _props_metrics === void 0 ? void 0 : _props_metrics.filter(isTruthy).map(function(metric, index) {
        return /*#__PURE__*/ React.createElement(Metric, _object_spread({
            key: index
        }, metric));
    })), /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-row flex-wrap md:hidden justify-center gap-x-6 gap-y-12  items-stretch"
    }, (_props_metrics1 = props.metrics) === null || _props_metrics1 === void 0 ? void 0 : _props_metrics1.filter(isTruthy).map(function(metric, index) {
        return /*#__PURE__*/ React.createElement(Metric, _object_spread({
            key: index
        }, metric));
    })));
}
var Metric = function(props) {
    var count = useMotionValue(0);
    var rounded = useTransform(count, function(latest) {
        return Math.round(latest);
    });
    var _React_useState = _sliced_to_array(React.useState(2), 2), numberOfDigits = _React_useState[0], setNumberOfDigits = _React_useState[1];
    useEffect(function() {
        setNumberOfDigits("".concat(props.value).length);
        var _props_value;
        animate(count, (_props_value = props.value) !== null && _props_value !== void 0 ? _props_value : 0, {
            duration: 1.5
        });
    }, []);
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        className: " bg-white border border-green-100 rounded-[0.3125rem] shadow-sm py-11 px-14 hidden md:flex flex-col items-center text-center"
    }, /*#__PURE__*/ React.createElement(motion.h3, {
        className: "text-9xl leading-9xl font-semibold font-sans text-lime-500 m-0 tabular-nums",
        "data-number": props.value,
        style: {
            width: "".concat(numberOfDigits, "ch")
        }
    }, rounded), /*#__PURE__*/ React.createElement("p", {
        className: "text-lg leading-lg m-0",
        style: {
            maxWidth: "".concat(numberOfDigits * 5.5, "rem")
        }
    }, props.description)), /*#__PURE__*/ React.createElement("div", {
        className: "md:hidden flex flex-col gap-4"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "bg-white border border-green-100 rounded-[0.3125rem] shadow-sm py-7 px-6 flex flex-col items-center text-center"
    }, /*#__PURE__*/ React.createElement(motion.h3, {
        className: "sm:text-[6rem] sm:leading-[6rem] text-8xl leading-8xl font-semibold font-sans text-lime-500 m-0 tabular-nums",
        "data-number": props.value,
        style: {
            maxWidth: "".concat(numberOfDigits, "ch")
        }
    }, rounded)), /*#__PURE__*/ React.createElement("p", {
        className: "text-lg leading-lg m-0 text-center",
        style: {
            maxWidth: "".concat(numberOfDigits * 5.5, "rem")
        }
    }, props.description)));
};
